import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App';
import { LogInSchoolID } from '../../JS/Common';
import { ApiPostCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import AlertPopup from '../../Components/AlertPopup';
import SettingBoxWrapper from './SettingBoxWrapper';
import useConfig from '../../Hooks/useConfig';

export default function UncoveredRepairDetails({ setLoading, setNewAlerts }) {
    const { UserData, setUserData } = useContext(UserContext);
    const { dcc_module_text, sm_dcc_text } = useConfig()
    const [Uncoveredcharge, setUncoveredcharge] = useState(UserData.repairflag)
    const [InNegotiationPopup, setInNegotiationPopup] = useState(false);
    useEffect(() => {
        setUncoveredcharge(UserData.repairflag)
    }, [UserData.repairflag])
    function UncoveredChange(flag) {
        if (flag != 1) {
            RepairChargeCall();
        } else {
            setInNegotiationPopup(true)
        }
    }
    async function RepairChargeCall() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            repairFlag: Uncoveredcharge
        })
        await ApiPostCall("/settings/repair-cost/visibility", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Repair Cost Updated Successfully"} />);
                    setInNegotiationPopup(false)
                    setTimeout(() => {
                        setUserData((prevUserData) => ({ ...prevUserData, repairflag: Uncoveredcharge }));
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
            }
        });
    }

    return (
        <>
            <SettingBoxWrapper
                BoxTitle={`${dcc_module_text} - Unenrolled Repair Cost`}
                BoxLabel={'Please select the type of cost for repairs that are not enrolled by the warranty.'}
            >
                <div className='col-md-12 mt-3 d-flex align-items-center'>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='repairflag'
                            onChange={(e) => setUncoveredcharge(1)}
                            defaultChecked={UserData.repairflag == 1}
                        />
                        <label className="form-check-label">Flat Fee</label>
                    </div>
                    <div className="form-check ms-5">
                        <input
                            className="form-check-input"
                            type="radio"
                            name='repairflag'
                            onChange={(e) => setUncoveredcharge(0)}
                            defaultChecked={UserData.repairflag != 1}
                        />
                        <label className="form-check-label">Full Repair</label>
                    </div>
                    <div className='px-5 text-center'>
                        <button className="SaveBtn" onClick={(e) => UncoveredChange(Uncoveredcharge)}>Confirm</button>
                    </div>
                </div>
            </SettingBoxWrapper>

            <AlertPopup isshow={InNegotiationPopup} img={'/images/redInfo.svg'}
                headingtext={`Are you sure?`} text={`Switching from "Full Repair" to "Flat Fee" with active ${sm_dcc_text} will cause clubs to back up for negotiation to determine unenrolled repair costs. Proceed?`}
                cancelcall={(e) => setInNegotiationPopup(false)}
                canceltext={"Cancel"} successtext={"Yes, Proceed!"} successcall={(e) => RepairChargeCall(e)} btntype={'deleteBtn'} />

        </>
    )
}
